<template>
  <div
    class="advent-calendar-window flexing"
    :class="[
      calendarWindow.status,
      'window-' + calendarWindow.order,
      {
        active: calendarWindow.order === currentWindow,
        interactive: isInteractive,
        selected: selectedWindow && calendarWindow.order === selectedWindow.order,
      },
    ]"
    @click="handleClick"
  >
    <div
      class="advent-calendar-window-number"
      :class="['number-' + calendarWindow.order, { centered: !hasReward }]"
    />

    <app-icon v-if="isLocked" class="advent-calendar-window-lock" icon-name="lock-sm" />

    <div v-else-if="isClaimed" class="advent-calendar-window-check" />

    <div v-if="calendarWindow.reward" class="advent-calendar-window-reward flexing">
      <app-main-icon
        class="advent-calendar-window-reward-icon"
        :icon-name="rewardIcon"
        :icon-size="80"
      />

      <p class="advent-calendar-window-reward-number">
        {{ calendarWindow.reward.value }}
      </p>
    </div>

    <div v-if="showOpenText" class="advent-calendar-window-open">
      {{ $t('event.open') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { mapState, mapActions } from 'pinia'
import { type CalendarWindowType, WindowStatus } from '@/interfaces/events/AdventCalendar'
import { useAdventCalendarStore } from '@/store/pinia/events/adventCalendarStore'

export default defineComponent({
  name: 'CalendarWindow',

  props: {
    calendarWindow: {
      type: Object as PropType<CalendarWindowType>,
      required: true,
    },

    isInteractive: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState(useAdventCalendarStore, ['currentWindow', 'selectedWindow']),

    isFuture(): boolean {
      return this.calendarWindow.status === WindowStatus.Future
    },

    isActive(): boolean {
      return this.calendarWindow.status === WindowStatus.Active
    },

    showOpenText(): boolean {
      return this.isActive && !this.calendarWindow.reward
    },

    isLocked(): boolean {
      return this.calendarWindow.status === WindowStatus.Future
    },

    isClaimed(): boolean {
      return this.calendarWindow.status === WindowStatus.Claimed
    },

    rewardIcon(): string {
      if (this.calendarWindow.reward.name.includes('benefit'))
        return 'benefit-' + this.calendarWindow.reward.gdd_id
      if (
        this.calendarWindow.reward.name.includes('grand_prize') &&
        this.calendarWindow.reward.rarity
      )
        return 'gp-' + this.calendarWindow.reward.rarity
      return this.calendarWindow.reward.name
    },

    hasReward(): boolean {
      return !!this.calendarWindow?.reward?.name
    },
  },

  methods: {
    ...mapActions(useAdventCalendarStore, ['selectWindow']),

    handleClick(): void {
      if (!this.isInteractive) return

      this.selectWindow(this.calendarWindow)
    },
  },
})
</script>

<style lang="scss" scoped>
@import '@/assets/styles/views/advent-calendar/window.scss';
</style>
